<script>
	import Button from '../shared/Button.svelte'
	import axios from 'axios'

	export let bot
	
	/*let errors = { url : '', description : '', image : '' }
	*/

	let testingMode = true,
		channel = 'Sandbox',
		postUrl,
		/*postDescription,
		postImageUrl, 
		postImage, 
		postImageData,*/
		robyMsg

	/*$: postImage ? image2Data(postImage) : ''*/
	$: channel = testingMode ? 'Sandbox' : 'oio news'

	/*let image2Data = files => {
		const file = files[0]
		const reader = new FileReader()

		reader.readAsDataURL(file)
		reader.onload = () => {
			postImageData = reader.result
		}
		reader.onerror = error => {
			console.log(error)
		}
	}*/

	let submit = () => {
		if (Boolean(postUrl) && Boolean(robyMsg)) {

			bot.post('/sockpuppet/instagram', {
				'url' : postUrl,
				'msg' : robyMsg,
				'testing' : testingMode
			}).then(r => {
				console.log(r)
			}).catch(e => {
				console.log(e)
			})

			postUrl = ''
			robyMsg = ''

		}
		/*if (Boolean(postUrl) && Boolean(postDescription) && Boolean(postImageData) && Boolean(robyMsg)) {

			bot.post('/sockpuppet/instagram', {
				'url' : postUrl,
				'description' : postDescription,
				'img': postImageData, 
				'msg' : robyMsg,
				'testing' : testingMode
			}).then(r => {
				console.log(r)
			}).catch(e => {
				console.log(e)
			})

			postUrl = ''
			postDescription = ''
			postImage = ''

		}*/	
	}
</script>

<div class='tool insta-sockpuppet' class:danger={!testingMode}>
	<h3>Instagram Post sockpuppet</h3>
	<p>
		Posts an Instagram post's data on Discord through roby.
	</p>
	<form on:submit|preventDefault={submit}>
		<div>
			<input name='testingMode' type='checkbox' bind:checked={testingMode}>
			<label for='testingMode'> 
				{#if testingMode}
					🌴 Testing mode (sandbox channel) 🌴
				{:else}
					🚨 Publish mode (official channel) 🚨
				{/if}
			</label>
		</div>

		<label for='url'>🌏 post url</label>
		<input name='url' type='text' bind:value={postUrl} placeholder='url of the post'>

		<!-- <label for='description'>post description</label>
		<input name='description' type='text' bind:value={postDescription} placeholder='text of the post'>

		<label for='postImage'>post image (.png)</label>
		<input type='file' name='postImage' accept='image/png' bind:files={postImage} size='1'/>

		<br> -->

		<label for='robyMsg'>🤖 roby message</label>
		<input name='robyMsg' type='text' bind:value={robyMsg} placeholder='What roby says when publishing'>


		<Button danger={!testingMode}>Publish on {channel}</Button>
	</form>
</div>

<style>
	
</style>